'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
var $ = require("jquery");
var Menu = /** @class */ (function () {
    function Menu() {
        $('.trigOpenMenu').on('click', function (e) {
            var open = $(e.currentTarget).attr('data-is-open');
            if (open === 'false') {
                $('.bulletMenu').fadeIn('slow');
                $(e.currentTarget).attr('data-is-open', 'true');
            }
            else {
                $('.bulletMenu').fadeOut('slow');
                $(e.currentTarget).attr('data-is-open', 'false');
            }
        });
        $('.trigCloseMenu').on('click', function () {
            $('.bulletMenu').fadeOut('slow');
            $('.trigOpenMenu').attr('data-is-open', 'false');
        });
        console.log('menu');
    }
    return Menu;
}());
exports.Menu = Menu;
exports.default = Menu;
